import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { handleMsalRedirectBridge } from './app/core/auth/msal-redirect-bridge';

async function main(): Promise<void> {
    // Reuse the registered '/' callback without bootstrapping Angular or loading
    // third-party scripts inside MSAL's silent/popup response windows.
    if (await handleMsalRedirectBridge()) return;

    if (environment.production) {
        enableProdMode();
    }

    const icons = document.createElement('script');
    icons.src = 'https://kit.fontawesome.com/c07bac5512.js';
    icons.crossOrigin = 'anonymous';
    document.head.appendChild(icons);

    if (environment.intelligenceEnabled) {
        const script = document.createElement('script');
        script.src = 'https://cdn.platform.openai.com/deployments/chatkit/chatkit.js';
        script.async = true;
        document.head.appendChild(script);
    }

    await bootstrapApplication(AppComponent, appConfig);
}

main().catch((err) => console.error(err));
